import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const QuestionMark: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 6 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M2.99995 5.10378V5.0292C2.99995 4.35327 3.47923 3.98676 3.95946 3.70547C4.4283 3.42997 4.89809 3.07091 4.89809 2.40905C4.89809 1.49485 4.04867 0.754395 2.99995 0.754395C1.95122 0.754395 1.10181 1.49485 1.10181 2.40905"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      // eslint-disable-next-line max-len
      d="M2.99898 6.83331C2.86801 6.83331 2.76171 6.91986 2.76266 7.0265C2.76266 7.13315 2.86896 7.2197 2.99993 7.2197C3.1309 7.2197 3.2372 7.13315 3.2372 7.0265C3.2372 6.91986 3.1309 6.83331 2.99898 6.83331"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
